import { parseStringToIntWithDefaultValue } from './converters/NumberConverter';
import { parseStringWithDefaultValue } from './converters/StringConverter';

const DESKTOP_MENU_WIDTH = 260;
const GRID_SIZE = 10;
const API_BASE_URL = 'https://localhost:8099';
const WEB_SOCKET_URL = 'ws://localhost:3000';
const DEFAULT_LANGUAGE_CODE = 'de-DE';
const MAX_STATUS_DAY = 300;
const MAX_DAYS_BEFORE_SWITCH_TO_RED = 30;
const DEBUG = 0;
const BASE64_SHARED_KEY = 'PzVCWTpnZXlAZnp2Qlc0UkE3OnQ+cGtDR1RaUERnTDU=';
const APP_VERSION = 'local';

interface CustomWindow extends Window {
  env?: {
    REACT_APP_DESKTOP_MENU_WIDTH: string;
    REACT_APP_GRID_SIZE: string;
    REACT_APP_API_BASE_URL: string;
    REACT_APP_WEB_SOCKET_URL: string;
    REACT_APP_DEFAULT_LANGUAGE_CODE: string;
    REACT_APP_MAX_STATUS_DAY: string;
    REACT_APP_MAX_DAYS_BEFORE_SWITCH_TO_RED: string;
    REACT_APP_DEBUG: string;
    REACT_APP_BASE64_SHARED_KEY: string;
    REACT_APP_APP_VERSION: string;
  };
}

const getEnv = () => (window as unknown as CustomWindow).env;

const getDesktopMenuWidth = (): number => {
  return parseStringToIntWithDefaultValue(
    getEnv()?.REACT_APP_DESKTOP_MENU_WIDTH,
    DESKTOP_MENU_WIDTH
  );
};

const getGridSize = (): number => {
  return parseStringToIntWithDefaultValue(getEnv()?.REACT_APP_GRID_SIZE, GRID_SIZE);
};

const getApiBaseUrl = (): string => {
  return parseStringWithDefaultValue(getEnv()?.REACT_APP_API_BASE_URL, API_BASE_URL);
};

const getWebSocketUrl = (): string => {
  return parseStringWithDefaultValue(getEnv()?.REACT_APP_WEB_SOCKET_URL, WEB_SOCKET_URL);
};

const getDefaultLanguageCode = (): string => {
  return parseStringWithDefaultValue(
    getEnv()?.REACT_APP_DEFAULT_LANGUAGE_CODE,
    DEFAULT_LANGUAGE_CODE
  );
};

const getMaxStatusDays = (): number => {
  return parseStringToIntWithDefaultValue(getEnv()?.REACT_APP_MAX_STATUS_DAY, MAX_STATUS_DAY);
};

const getMaxDaysBeforeSwitchToRed = (): number => {
  return parseStringToIntWithDefaultValue(
    getEnv()?.REACT_APP_MAX_DAYS_BEFORE_SWITCH_TO_RED,
    MAX_DAYS_BEFORE_SWITCH_TO_RED
  );
};

const getDebug = (): number => {
  return parseStringToIntWithDefaultValue(getEnv()?.REACT_APP_DEBUG, DEBUG);
};

const getBase64SharedKey = (): string => {
  return parseStringWithDefaultValue(getEnv()?.REACT_APP_BASE64_SHARED_KEY, BASE64_SHARED_KEY);
};

const getVersion = (): string => {
  return parseStringWithDefaultValue(getEnv()?.REACT_APP_APP_VERSION, APP_VERSION);
};

export {
  getDesktopMenuWidth,
  getGridSize,
  getApiBaseUrl,
  getWebSocketUrl,
  getDefaultLanguageCode,
  getMaxStatusDays,
  getMaxDaysBeforeSwitchToRed,
  getDebug,
  getBase64SharedKey,
  getVersion,
};
